import { PDFDocument } from 'pdf-lib';

// API base url
export const Apiurl = () => {
  return "https://utdbttstg.dilonline.in/api";
};
// Image url
export const Imageurl = () => {
  return "https://utdbttstg.dilonline.in/backend/images/categories";
};
// Image url
export const ImageurlIcons = () => {
  return "https://utdbttstg.dilonline.in/backend/images/icons";
};
export const Baseurl = () => {
  return "https://utdbttstg.dilonline.in";
};

export const PdfBaseUrl = () => {
  return `${window?.location?.origin}/admin/traveltradepdf/pdfs`;
};

export const DocsBaseUrl = () => {
  return `${window?.location?.origin}/traveltradedocs/docs`;
};

export const DocsBaseUrlAdmin = () => {
  return `${window?.location?.origin}/admin/traveltradedocs/docs`;
};

export const alphaSpaceRegex = /^[A-Za-z ]*$/;
export const numericRegex = /^[0-9]*$/;
export const scriptRegex = /<[^>]*>/g;
// get data from ls
// Get from sessionStorage first, fallback to localStorage
export const GetLocalStorage = (item) => {
  const sessionData = sessionStorage.getItem(item);
  return sessionData || localStorage.getItem(item) || null;
};

// Get and parse data from sessionStorage first, fallback to localStorage
export const GetLocalStorageParsed = (item) => {
  const sessionData = sessionStorage.getItem(item);
  if (sessionData) {
    return JSON.parse(sessionData);
  }
  const localData = localStorage.getItem(item);
  return localData && localData !== "undefined" ? JSON.parse(localData) : null;
};

// Set data to both sessionStorage and localStorage
export const SetLocalStorage = (item, value) => {
  sessionStorage.setItem(item, value);
  localStorage.setItem(item, value);
};

// Set stringify data to both sessionStorage and localStorage
export const SetLocalStorageStringify = (item, value) => {
  const stringifiedValue = JSON.stringify(value);
  sessionStorage.setItem(item, stringifiedValue);
  localStorage.setItem(item, stringifiedValue);
};

// Remove from sessionStorage and localStorage
export const RemoveLocalStorage = (item) => {
  sessionStorage.removeItem(item);
  localStorage.removeItem(item);
};

// Parse data (this is not impacted by storage choice)
export const parseData = (item) => {
  return JSON.parse(item);
}

// Stringify data (this is not impacted by storage choice)
export const stringifyData = (item) => {
  return JSON.stringify(item);
}

// Clear sessionStorage and localStorage
export const ClearLocalStorage = () => {
  sessionStorage.clear();
  localStorage.clear();
};

// Remove user session (clear both sessionStorage and localStorage)
export const RemoveSession = (navigate) => {
  sessionStorage.clear();
  localStorage.clear();
  navigate('/');
};
export const validateonChangeHandle = (list, value, dataList, setDataList) => {

  const data = JSON.parse(list?.validations)
  const eee = JSON.parse(data?.validation)?.onChange
  for (let item of eee) {
    let newValue = value.target.value;
    if (newValue.startsWith(' ')) {
      newValue = newValue.trimStart();
    }
    // if (item?.type == "numeric" && item?.unit == "Required") {

    // }
    // else if (item?.type == "numeric" && item?.unit == "Less than") { 

    // }
    // else if (item?.type == "numeric" && item?.unit == "Greater than") { 

    // }
    // else if (item?.type == "numeric" && item?.unit == "Not equal to") { 

    // }
    // else if (item?.type == "numeric" && item?.unit == "Equal to") {

    //  }

    if (item?.type == "numeric" && item?.unit == "Number limit") {
      const min = parseInt(Number(item?.numberLowerLimit), 10);
      const max = parseInt(Number(item?.numberUpperLimit), 10);
      if (!isNaN(min) && !isNaN(max) && min <= max) {
        const result = [];
        for (let i = min; i <= max; i++) {
          result.push(i);
        }

        if (newValue?.length > 0 && result.includes(Number(newValue[0]))) {

          newValue = newValue.slice(1);
          const updatedFields = dataList.map(field => {
            if (field.id === list?.id) {
              return {
                ...field,
                value: newValue
              };
            }
            return field;
          });
          setDataList(updatedFields);
          return false

        } else {

          const updatedFields = dataList.map(field => {
            if (field.id === list?.id) {
              return {
                ...field,
                value: newValue
              };
            }
            return field;
          });
          setDataList(updatedFields);
        }
      }


    }
    else if (item?.type == "numeric" && item?.unit == "Maximum length") {
      if (newValue.length >= item?.value) {
        newValue = newValue.slice(0, item?.value);
        const updatedFields = dataList.map(field => {
          if (field.id === list?.id) {
            return {
              ...field,
              value: newValue
            };
          }
          return field;
        });
        setDataList(updatedFields);
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id === list?.id) {
            return {
              ...field,
              value: newValue
            };
          }
          return field;
        });
        setDataList(updatedFields);
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Numbers (0-9) only") {


      newValue = newValue.replace(/\D/g, '');

      const updatedFields = dataList.map(field => {
        if (field.id === list?.id) {
          return {
            ...field,
            value: newValue
          };
        }
        return field;
      });
      setDataList(updatedFields);
      return false



    }
    // else if (item?.type == "numeric" && item?.unit == "Specify number range") { }
    // else if (item?.type == "numeric" && item?.unit == "Integer Only") { }
    // else if (item?.type == "numeric" && item?.unit == "Decimal Only with  precision and scale") { }
    // else if (item?.type == "numeric" && item?.unit == "Positive number only") { }
    // else if (item?.type == "numeric" && item?.unit == "Negative number only") { }
    // else if (item?.type == "text" && item?.unit == "Required") { }
    else if (item?.type == "text" && item?.unit == "Not equal to") {

      const regex = new RegExp(item.value, 'g');
      newValue = newValue.replace(regex, '');
      const updatedFields = dataList.map(field => {
        if (field.id === list?.id) {
          return {
            ...field,
            value: newValue
          };
        }
        return field;
      });
      setDataList(updatedFields);
    }
    // else if (item?.type == "text" && item?.unit == "Equal to") { }
    else if (item?.type == "text" && item?.unit == "Maximum length") {

      if (newValue.length >= Number(item?.value)) {
        newValue = newValue.slice(0, Number(item?.value));
        const updatedFields = dataList.map(field => {
          if (field.id === list?.id) {
            return {
              ...field,
              value: newValue
            };
          }
          return field;
        });
        setDataList(updatedFields);
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id === list?.id) {
            return {
              ...field,
              value: newValue
            };
          }
          return field;
        });
        setDataList(updatedFields);
      }
    }
    // else if (item?.type == "text" && item?.unit == "Lowercase (a-z) only") { }
    // else if (item?.type == "text" && item?.unit == "Uppercase (A-Z) only") { }
    else if (item?.type == "text" && item?.unit == "Alphabets (a-zA-Z) only") {
      newValue = newValue.replace(/[^a-zA-Z\s]/g, '');
      const updatedFields = dataList.map(field => {
        if (field.id === list?.id) {
          return {
            ...field,
            value: newValue
          };
        }
        return field;
      });
      setDataList(updatedFields);
    }
    // else if (item?.type == "text" && item?.unit == "Special characters (@$!%*?&)") { }
    // else if (item?.type == "text" && item?.unit == "Email only") { }
    // else if (item?.type == "text" && item?.unit == "Website only") { }
  };
}
export const validateonKeyUpHandle = (list, value, dataList, setDataList) => {
  // //console.log("listgvv" +list?.type)
  // //console.log("list?.validations", list?.validations)
  const data = JSON.parse(list?.validations)
  const eee = JSON.parse(data?.validation)?.onKeyUp
  for (let item of eee) {
    if (item?.type == "numeric" && item?.unit == "Required") {
      if (!value || value.trim() == "") {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Less than") {
      if (value.length < Number(item?.value)) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Greater than") {
      if (value?.length > Number(item?.value)) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Not equal to") {
      if (Number(value) !== Number(item?.value)) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Equal to") {
      if (Number(value) == Number(item?.value)) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Maximum length") {
      if (value?.length > Number(item?.value)) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Numbers (0-9) only") {
      if (!(/[0-9]/.test(value))) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Number limit") {
      const min = Number(item?.numberLowerLimit);
      const max = Number(item?.numberUpperLimit);
      if (!isNaN(min) && !isNaN(max) && min <= max) {
        const result = [];
        for (let i = min; i <= max; i++) {
          result.push(`${i}`);
        }
        if (!result.includes(value)) {
          const updatedFields = dataList.map(field => {
            if (field.id == list?.id) {
              return {
                ...field,
                error: { hi: item?.messageHindi, en: item?.messageEnglish }
              };
            }
            return field;
          });
          setDataList(updatedFields)
          return false
        } else {
          const updatedFields = dataList.map(field => {
            if (field.id == list?.id) {
              return {
                ...field,
                error: ""
              };
            }
            return field;
          });
          setDataList(updatedFields)
        }
      }

    }
    else if (item?.type == "numeric" && item?.unit == "Specify number range") {
      const min = Number(item?.numberLowerLimit);
      const max = Number(item?.numberUpperLimit);
      if (Number(value) < min && Number(value) > max) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Integer Only") {
      if (!(/^-?\d*$/.test(Number(item?.value)))) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Decimal Only with  precision and scale") {
      if (!(/^\d*\.?\d{0,2}$/.test(Number(item?.value)))) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Positive number only") {
      if (!(/^\d*$/.test(Number(item?.value)))) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Negative number only") {
      if (!(/^-?\d*$/.test(Number(item?.value))) && !(Number(item?.value) === '-' || Number(item?.value) !== '')) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "text" && item?.unit == "Required") {
      if (!value) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              value: value,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              value: value,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "text" && item?.unit == "Not equal to") {
      if (value?.length !== Number(item?.value)) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "text" && item?.unit == "Equal to") {
      if (value?.length == Number(item?.value)) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }

    }
    else if (item?.type == "text" && item?.unit == "Maximum length") {
      if (value?.length > Number(item?.value)) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "text" && item?.unit == "Lowercase (a-z) only") {
      if (!(/[a-z]/.test(value))) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "text" && item?.unit == "Uppercase (A-Z) only") {
      if (!(/[A-Z]/.test(value))) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "text" && item?.unit == "Alphabets (a-zA-Z) only") {
      if (!(/^[a-zA-Z]*$/.test(value))) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "text" && item?.unit == "Special characters (@$!%*?&)") {
      if (!(/[\!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\<\>\=\?\@\[\]\{\}\\\\\^\_\`\~]/.test(value))) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "text" && item?.unit == "Email only") {
      if (!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value))) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }
    else if (item?.type == "text" && item?.unit == "Website only") {
      const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;
      if (!(urlPattern.test(value))) {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: { hi: item?.messageHindi, en: item?.messageEnglish }
            };
          }
          return field;
        });
        setDataList(updatedFields)
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id == list?.id) {
            return {
              ...field,
              error: ""
            };
          }
          return field;
        });
        setDataList(updatedFields)
      }
    }

  }
}

export const validateonSubmitHandle = (list, value, dataList) => {

  const data = JSON.parse(list?.validations)
  const eee = JSON.parse(data?.validation)?.onKeyUp
  for (let item of eee) {
    if (item?.type == "numeric" && item?.unit == "Required") {
      if (!value || value.trim() == "") {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Less than") {
      if (value.length < Number(item?.value)) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Greater than") {
      if (value.length > Number(item?.value)) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Not equal to") {
      if (Number(value) !== Number(item?.value)) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Equal to") {
      if (Number(value) == Number(item?.value)) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Maximum length") {
      if (value?.length > Number(item?.value)) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Numbers (0-9) only") {
      if (!(/[0-9]/.test(value))) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Number limit") {
      const min = Number(item?.numberLowerLimit);
      const max = Number(item?.numberUpperLimit);
      if (!isNaN(min) && !isNaN(max) && min <= max) {
        const result = [];
        for (let i = min; i <= max; i++) {
          result.push(`${i}`);
        }
        if (!result.includes(value)) {
          return {
            hi: item?.messageHindi, en: item?.messageEnglish
          };
        }
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Specify number range only") {
      const min = Number(item?.numberLowerLimit);
      const max = Number(item?.numberUpperLimit);
      if (Number(value) < min || Number(value) > max) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Integer Only") {
      if (!(/^-?\d*$/.test(Number(value)))) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Decimal Only with  precision and scale") {
      if (!(/^\d*\.?\d{0,2}$/.test(Number(value)))) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Positive number only") {
      if (eee.filter((e) => e.unit == "Decimal Only with  precision and scale")?.length > 0) {
        if (!(/^\d*$/.test(Number(value)) || /^\d*\.?\d{0,9}$/.test(Number(value)))) {
          return {
            hi: item?.messageHindi, en: item?.messageEnglish
          };
        }
      } else {
        if (!(/^\d*$/.test(Number(value)))) {
          return {
            hi: item?.messageHindi, en: item?.messageEnglish
          };
        }
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Negative number only") {
      if (!(/^-?\d*$/.test(Number(value))) && !(Number(value) === '-' || Number(value) !== '')) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "text" && item?.unit == "Required") {
      if (!value) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "text" && item?.unit == "Not equal to") {
      if (value?.length === Number(item?.value)) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "text" && item?.unit == "Equal to") {
      if (value?.length !== Number(item?.value)) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "text" && item?.unit == "Maximum length") {
      if (value?.length > Number(item?.value)) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "text" && item?.unit == "Lowercase (a-z) only") {
      if (!(/[a-z]/.test(value))) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "text" && item?.unit == "Uppercase (A-Z) only") {
      if (!(/[A-Z]/.test(value))) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "text" && item?.unit == "Alphabets (a-zA-Z) only") {
      if (!(/^[a-zA-Z\s]*$/.test(value))) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "text" && item?.unit == "Special characters (@$!%*?&)") {
      if (!(/[\!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\<\>\=\?\@\[\]\{\}\\\\\^\_\`\~]/.test(value))) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "text" && item?.unit == "Email only") {
      if (!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value))) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
    else if (item?.type == "text" && item?.unit == "Website only") {
      const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;
      if (!(urlPattern.test(value))) {
        return {
          hi: item?.messageHindi, en: item?.messageEnglish
        };
      }
    }
  }
  return "";
}

export const formOnChangeValidation = (list, value, dataList, setDataList) => {

  const data = JSON.parse(list?.validations)
  const eee = JSON.parse(data?.validation)?.onChange
  for (let item of eee) {
    let newValue = value.target.value;
    if (newValue.startsWith(' ')) {
      newValue = newValue.trimStart();
    }
    if (item?.type == "numeric" && item?.unit == "Number limit") {
      const min = parseInt(Number(item?.numberLowerLimit), 10);
      const max = parseInt(Number(item?.numberUpperLimit), 10);
      if (!isNaN(min) && !isNaN(max) && min <= max) {
        const result = [];
        for (let i = min; i <= max; i++) {
          result.push(i);
        }
        if (newValue?.length > 0 && result.includes(Number(newValue[0]))) {
          newValue = newValue.slice(1);
          const updatedFields = dataList.map(field => {
            if (field.id === list?.id) {
              return {
                ...field,
                value: newValue
              };
            }
            return field;
          });
          setDataList(updatedFields);
          return false

        } else {
          const updatedFields = dataList.map(field => {
            if (field.id === list?.id) {
              return {
                ...field,
                value: newValue
              };
            }
            return field;
          });
          setDataList(updatedFields);
        }
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Maximum length") {
      if (newValue.length >= item?.value) {
        newValue = newValue.slice(0, item?.value);
        const updatedFields = dataList.map(field => {
          if (field.id === list?.id) {
            return {
              ...field,
              value: newValue
            };
          }
          return field;
        });
        setDataList(updatedFields);
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id === list?.id) {
            return {
              ...field,
              value: newValue
            };
          }
          return field;
        });
        setDataList(updatedFields);
      }
    }
    else if (item?.type == "numeric" && item?.unit == "Numbers (0-9) only") {
      newValue = newValue.replace(/\D/g, '');
      const updatedFields = dataList.map(field => {
        if (field.id === list?.id) {
          return {
            ...field,
            value: newValue
          };
        }
        return field;
      });
      setDataList(updatedFields);
      return false
    }
    else if (item?.type == "text" && item?.unit == "Not equal to") {
      const regex = new RegExp(item.value, 'g');
      newValue = newValue.replace(regex, '');
      const updatedFields = dataList.map(field => {
        if (field.id === list?.id) {
          return {
            ...field,
            value: newValue
          };
        }
        return field;
      });
      setDataList(updatedFields);
    }
    // else if (item?.type == "text" && item?.unit == "Equal to") { }
    else if (item?.type == "text" && item?.unit == "Maximum length") {

      if (newValue.length >= Number(item?.value)) {
        newValue = newValue.slice(0, Number(item?.value));
        const updatedFields = dataList.map(field => {
          if (field.id === list?.id) {
            return {
              ...field,
              value: newValue
            };
          }
          return field;
        });
        setDataList(updatedFields);
        return false
      } else {
        const updatedFields = dataList.map(field => {
          if (field.id === list?.id) {
            return {
              ...field,
              value: newValue
            };
          }
          return field;
        });
        setDataList(updatedFields);
      }
    }
    else if (item?.type == "text" && item?.unit == "Alphabets (a-zA-Z) only") {
      newValue = newValue.replace(/[^a-zA-Z\s]/g, '');
      const updatedFields = dataList.map(field => {
        if (field.id === list?.id) {
          return {
            ...field,
            value: newValue
          };
        }
        return field;
      });
      setDataList(updatedFields);
    }
  };
}


/**
 * PDF File checking functions
 * @param {*} file 
 * @returns 
 */
export const checkIfPDFIsEncrypted = async (file) => {
  try {
    // If the PDF loads without an error, it's not password protected
    const arrayBuffer = await file.arrayBuffer();
    await PDFDocument.load(arrayBuffer, { throwOnInvalidObject: true });

    return false;
  } catch (error) {
    // If the PDF loads with an error, it's password protected

    if (error.message.includes("encrypted")) {
      return true;

    }
  }
};

const hasDoubleExtension = (fileName) => {
  const parts = fileName.split(".");
  return parts.length > 2; // More than two parts indicates a double extension
};

/**
* Function to check if the pdf contains javascript data or not 
* return ture in case having the script data
* @param data 
* @returns 
*/
export const checkMaliciousPdf = (file) => {
  return new Promise((resolve) => {
    if (hasDoubleExtension(file.name)) {
      resolve(true); // File is invalid due to double extension
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const arrayBuffer = reader.result;
      const uint8Array = new Uint8Array(arrayBuffer);
      const decoder = new TextDecoder("utf-8");
      const fileContent = decoder.decode(uint8Array).toLowerCase();

      if (
        fileContent.includes("javascript") ||
        fileContent.includes("alert") ||
        fileContent.includes("confirm") ||
        fileContent.includes("prompt")
      ) {
        resolve(true); // File is invalid
      } else {
        resolve(false); // File is valid
      }
    };

    reader.onerror = () => {
      resolve(true); // Consider the file invalid on error
    };

    reader.readAsArrayBuffer(file);
  });
}

export const extractUserFormPdfPath = (path) => {
  const segments = path.split('/');
  return `${segments[segments?.length - 3]}/${segments[segments?.length - 2]}`; // Combine them into one string
};

export const extractUserFormPdfFileName = (path) => {
  const segments = path.split('/');
  return `${segments[segments?.length - 1]}`; // Combine them into one string
};

export const isDisallowedFileType = (file) => {
  return new Promise((resolve, reject) => {
    try {
      // Check if the file is empty
      if (file.size === 0) {
        resolve(true);
        return;
      }

      // Valid MIME types (this list can be expanded as needed)
      const allowedFileTypes = [
        { label: "Docx", value: "1", mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" },
        { label: "PDF", value: "2", mime: "application/pdf" },
        { label: "Xlsx", value: "3", mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
        { label: "Pptx", value: "4", mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation" },
        { label: "Txt", value: "5", mime: "text/plain" },
        { label: "Csv", value: "6", mime: "text/csv" },
        { label: "Jpg/Jpeg", value: "7", mime: "image/jpeg" },
        { label: "Png", value: "8", mime: "image/png" },
        { label: "Doc", value: "9", mime: "application/msword" }  // Added this line for .doc files
      ];

      const fileName = file.name.toLowerCase();
      if (fileName.includes("..") || /\/|;|<|>|\*|\?|\\|"/.test(fileName)) {
        resolve(true); // Reject files with suspicious characters or double extensions
        return;
      }

      // Check if the file MIME type is in the allowed list
      const isAllowedMimeType = allowedFileTypes.some(fileType => file.type === fileType.mime);
      if (!isAllowedMimeType) {
        resolve(true); // Reject file if it's not in the allowed list
        return;
      }

      const reader = new FileReader();

      reader.onload = () => {
        try {
          const arrayBuffer = reader.result;
          const uint8Array = new Uint8Array(arrayBuffer);

          // Check magic number or file signature to validate content
          const firstBytes = uint8Array.slice(0, 4); // Check the first few bytes (magic number)

          // Example content checks for specific valid file types:

          // Check for PDF files (PDF files typically start with %PDF)
          if (file.type === 'application/pdf' && !(firstBytes[0] === 37 && firstBytes[1] === 80 && firstBytes[2] === 68 && firstBytes[3] === 70)) {
            resolve(true); // Reject PDF files that don't start with the expected signature
            return;
          }

          // Check for JPEG files (JPEG files start with 0xFFD8)
          if (file.type === 'image/jpeg' && !(firstBytes[0] === 255 && firstBytes[1] === 216 && firstBytes[2] === 255)) {
            resolve(true); // Reject JPEG files that don't start with the expected signature
            return;
          }

          // Check for PNG files (PNG files start with 0x89504E47)
          if (file.type === 'image/png' && !(firstBytes[0] === 137 && firstBytes[1] === 80 && firstBytes[2] === 78 && firstBytes[3] === 71)) {
            resolve(true); // Reject PNG files that don't start with the expected signature
            return;
          }

          // Check for GIF files (GIF files typically start with GIF87a or GIF89a)
          if (file.type === 'image/gif' && !(firstBytes[0] === 71 && firstBytes[1] === 73 && firstBytes[2] === 70 && firstBytes[3] === 56)) {
            resolve(true); // Reject GIF files that don't start with the expected signature
            return;
          }

          if (file.type === 'application/msword' && !(firstBytes[0] === 208 && firstBytes[1] === 207 && firstBytes[2] === 17 && firstBytes[3] === 224)) {
            resolve(true); // Reject DOC files that don't start with the expected signature
            return;
          }

          // Check for DOCX, PPTX, XLSX files (these are ZIP archives, so they start with PK\x03\x04)
          if (
            (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || 
            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
            file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') && 
            !(firstBytes[0] === 80 && firstBytes[1] === 75 && firstBytes[2] === 3 && firstBytes[3] === 4)
          ) {
            resolve(true); // Reject DOCX, PPTX, XLSX files that don't start with the expected signature
            return;
          }

          // Check for CSV files (CSV files don't have a specific magic number, only MIME type is checked)
          if (file.type === 'text/csv') {
            // CSV files don't have a specific magic number, we only check the MIME type
            resolve(false); // Accept CSV files
            return;
          }

          resolve(false); // File is valid, no issues found
        } catch (err) {
          resolve(false);
        }
      };

      reader.onerror = () => {
        resolve(false);
      };

      reader.readAsArrayBuffer(file); // Start reading the file as an ArrayBuffer
    } catch (err) {
      resolve(false);
    }
  });
};







